import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ScadenzeArticoli } from 'src/app/models/scadenze-articoli';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScadenzeArticoliService {
  private http = inject(HttpClient);



  scadenzeUrl = environment.ildatoArticoliDpi + 'api/scadenzearticoli';



  list(): Observable<ScadenzeArticoli[]> {
    return this.http.get<ScadenzeArticoli[]>(this.scadenzeUrl);
  }

  listByArticolo(idArticolo: number): Observable<ScadenzeArticoli[]> { 
    return this.http.get<ScadenzeArticoli[]>(this.scadenzeUrl  + '/byart/'+ idArticolo); 
  }

  get(id:number): Observable<ScadenzeArticoli> {
    return this.http.get<ScadenzeArticoli>(this.scadenzeUrl  + '/'+ id);
    
  }

  insert(values: ScadenzeArticoli): Observable<ScadenzeArticoli> {
    console.log(values);    
    return this.http.post<ScadenzeArticoli>(this.scadenzeUrl, values);
  }

  remove(codCope: number): Observable<ScadenzeArticoli> {
    console.log(codCope);    
    return this.http.delete<ScadenzeArticoli>(this.scadenzeUrl + '/'+ codCope );
  }

  update(key: number, values: ScadenzeArticoli): Observable<ScadenzeArticoli> {
    console.log(values);    
    return this.http.put<ScadenzeArticoli>(this.scadenzeUrl + '/'+ key , values);
  }

}
